var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"position-fixed fixed-top m-0 rounded-0",staticStyle:{"z-index":"20000"},attrs:{"show":_vm.showAlert,"variant":"danger","dismissible":""}},[_vm._v(" Something Wrong Happened, Please contact IT team. Thanks ! ")])
}
var staticRenderFns = []

export { render, staticRenderFns }